module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'app page-' + _vm.activeRoute,
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('c-main-nav')], 1), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "name": "slide-fade-down",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('c-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 263
// module chunks = 0